
import { AnimatedCard } from '@shared/ui/animated-card/animated-card'
import s from './add-appointment.module.scss'
import { Button } from '@shared/ui/button/button'

export const AddAppointment = ({time, onClick, key}) => {
	return (
			<AnimatedCard layoutId={key}>
				<Button label={time + ' добавить занятие'} theme='secondary' className={s.addAppointmentButton} onClick={onClick}/>
			</AnimatedCard>
	)
}
